module.exports = __webpack_public_path__ + "img/forbes.34502152.svg";